<footer class="fixed bottom-0 end-0 start-0 py-3">
  <div class="container">
    <p class="text-center text-base font-medium text-gray-400">
      {{ currentYear }}
      © Ekklesia -
      <a href="https://servigram.net.co/" target="_blank" rel="noopener noreferrer"
        style="color: inherit; text-decoration: none;">
        Diseñado by SERVIGRAM
      </a>
    </p>
  </div>
</footer>